module.exports = __webpack_public_path__ + "img/azure1.f09ef471.svg";